import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UpdatedByModel } from '@shared/data-access/models';

@Component({
  /* eslint-disable @angular-eslint/component-selector */
  selector: 'red-last-updated-information',
  templateUrl: './last-updated-information.component.html',
  styleUrls: ['./last-updated-information.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LastUpdatedInformationComponent {
  @Input() updatedBy: UpdatedByModel | null | undefined = null;
  @Input() updatedAt: string | Date | null | undefined = null;
  @Input() datetimeFormat = 'dd MMM yyyy hh:mm a';
}
